module.exports = __webpack_public_path__ + "img/view-order1s.0574cf68.jpg";